<template>
  <div>
    <TopHeader2 underlineItem="گالری تصاویر"></TopHeader2>
    <section class="logo-header-resp d-md-none my-5">
      <div class="mx-auto"><img src="@/assets/images/logos/logoBlack.png" alt=""></div>
    </section>
        <div @click.self="showVideoBox=false" id="showVideoBox" v-if="showVideoBox">
        <button id="closeModal" @click="showVideoBox=false">
          <svg fill="#000000" xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 30 30" width="30px" height="30px">    <path d="M 7 4 C 6.744125 4 6.4879687 4.0974687 6.2929688 4.2929688 L 4.2929688 6.2929688 C 3.9019687 6.6839688 3.9019687 7.3170313 4.2929688 7.7070312 L 11.585938 15 L 4.2929688 22.292969 C 3.9019687 22.683969 3.9019687 23.317031 4.2929688 23.707031 L 6.2929688 25.707031 C 6.6839688 26.098031 7.3170313 26.098031 7.7070312 25.707031 L 15 18.414062 L 22.292969 25.707031 C 22.682969 26.098031 23.317031 26.098031 23.707031 25.707031 L 25.707031 23.707031 C 26.098031 23.316031 26.098031 22.682969 25.707031 22.292969 L 18.414062 15 L 25.707031 7.7070312 C 26.098031 7.3170312 26.098031 6.6829688 25.707031 6.2929688 L 23.707031 4.2929688 C 23.316031 3.9019687 22.682969 3.9019687 22.292969 4.2929688 L 15 11.585938 L 7.7070312 4.2929688 C 7.5115312 4.0974687 7.255875 4 7 4 z"/></svg>
        </button>
  <video-player  class="video-player-box"
                 ref="videoPlayer"
                 :options="playerOptions"
          
                 @ready="playerReadied">
  </video-player>

    </div>
    <main v-if="videos" class="main">
      <PagesPath :items="['گالری','ویدیوها ']" :last="'gallery'"></PagesPath>
      <section class="photos-grid container my-5">
        <template  v-for="(item, index) in videos.data">
        
            
          
          <article v-if="item.video" :key="index" class="photo-item border text-right">
            <div class="photo-item-img bg-color-c8">
              <img :src="item.cover.url" :alt="item.title">
              <button class="bg-none" @click="showVideo(item.video.url)">
                <svg class="icon" width="100%" height="100%"><use href="@/assets/svgIcons/svgIcons.svg/#videoPlay"></use></svg>
              </button>
            </div>
            <div class="photo-item-content p-3">
              <h6 class="fontsize-medium text-color-222">{{item.title}}  </h6>
              <div class="d-flex justify-content-between mt-5">
                <div>
                  <svg class="icon ml-1" width="14" height="14"><use href="@/assets/svgIcons/svgIcons.svg/#time"></use></svg>
                  <span class="fontsize-mini text-color-444">{{new Date(item.created_at).toLocaleDateString('fa')}} </span>
                </div>
                <button class="fontsize-mini px-3" @click="showVideo(item.video.url)">مشاهده</button>
              </div>
            </div>
          </article>
        </template>


      </section>
        <div v-if="videos" class="pagination-items" style="z-index: 2">
        <pagination
          :limit="1"
          :data="videos"
          @pagination-change-page="changePage"
          :disabled="disabled"
          class="justify-content-center"
        >
          <span slot="prev-nav">
            <svg
              class="page-arrow"
              xmlns="http://www.w3.org/2000/svg"
              x="0px"
              y="0px"
              width="20"
              height="20"
              viewBox="0 0 226 226"
              style="fill: #000000"
            >
              <g
                fill="none"
                fill-rule="nonzero"
                stroke="none"
                stroke-width="1"
                stroke-linecap="butt"
                stroke-linejoin="miter"
                stroke-miterlimit="10"
                stroke-dasharray=""
                stroke-dashoffset="0"
                font-family="none"
                font-weight="none"
                font-size="none"
                text-anchor="none"
                style="mix-blend-mode: normal"
              >
                <path d="M0,226v-226h226v226z" fill="none"></path>
                <g fill="#b2b2b2">
                  <path
                    d="M82.80781,169.67656c1.05938,1.05937 2.47187,1.58906 3.70781,1.58906c1.23594,0 2.64844,-0.52969 3.70781,-1.58906l52.96875,-52.96875c2.11875,-2.11875 2.11875,-5.47344 0,-7.41563l-52.96875,-52.96875c-2.11875,-2.11875 -5.47344,-2.11875 -7.41563,0c-2.11875,2.11875 -2.11875,5.47344 0,7.41563l49.26094,49.26094l-49.26094,49.26094c-2.11875,2.11875 -2.11875,5.29688 0,7.41562z"
                  ></path>
                </g>
              </g>
            </svg>
          </span>
          <span slot="next-nav">
            <svg
              class="page-arrow"
              xmlns="http://www.w3.org/2000/svg"
              x="0px"
              y="0px"
              width="20"
              height="20"
              viewBox="0 0 226 226"
              style="fill: #000000"
            >
              <g
                fill="none"
                fill-rule="nonzero"
                stroke="none"
                stroke-width="1"
                stroke-linecap="butt"
                stroke-linejoin="miter"
                stroke-miterlimit="10"
                stroke-dasharray=""
                stroke-dashoffset="0"
                font-family="none"
                font-weight="none"
                font-size="none"
                text-anchor="none"
                style="mix-blend-mode: normal"
              >
                <path d="M0,226v-226h226v226z" fill="none"></path>
                <g fill="#b2b2b2">
                  <path
                    d="M143.19219,56.32344c-2.11875,-2.11875 -5.47344,-2.11875 -7.41563,0l-52.96875,52.96875c-2.11875,2.11875 -2.11875,5.47344 0,7.41562l52.96875,52.96875c1.05937,1.05937 2.47188,1.58906 3.70781,1.58906c1.23594,0 2.64844,-0.52969 3.70781,-1.58906c2.11875,-2.11875 2.11875,-5.47344 0,-7.41563l-49.26094,-49.26094l49.26094,-49.26094c2.11875,-2.11875 2.11875,-5.29687 0,-7.41563z"
                  ></path>
                </g>
              </g>
            </svg>
          </span>
        </pagination>
      </div>
    </main>
    <loader v-else />
  </div>
</template>

<script>
import TopHeader2 from "../components/TopHeader2";
import PagesPath from "../components/PagesPath";
 import loader from "@/components/loader.vue" 

export default {
  name: "Videos",
  components:{
    TopHeader2,loader,
    PagesPath
  },
  mounted() {
    
    if(this.$route.query.type){
      this.type=this.$route.query.type=='partner'?'partner':'main'
    }else{
      this.type='main'
    }
    this.$axios.get(`/videos?type=${this.type}&page=${this.$route.query.page?this.$route.query.page:1}`).then(response=>{
      this.videos=response.data.videos;
    })
    document.querySelectorAll('.photo-item-img').forEach(item=>{
      item.style.height = item.offsetWidth + 'px';
    })
  } ,metaInfo() {
    return {
      title:"ویدیوها",
    
    };
  }
  ,
  data(){
    return{
      type:"",
      videos:null,
      showVideoBox:false,
            playerOptions: {
         autoplay: true,
          sources: [{
            type: "video/mp4",     
            src: null,
          }],
          poster: "/static/images/author.jpg",
        },
    }
  },
  methods:{
    changePage(event) {
        this.$axios.get(`/videos?type${this.type}&page=${event}`).then((res) => {
          this.videos = res.data.videos;
        })
       this.$router.replace({ name: "videos",  query: {page:event} })
    },
    showVideo(video){
      this.playerOptions.sources[0].src=video;
      this.showVideoBox=true;
    }
  }
}
</script>

<style scoped>
.photo-item{
  position: relative;
  border-radius: 15px;
  overflow: hidden;
  background-color: white;
}
.photo-item-img{
  position: relative;
  width: 100%;
}
.photo-item-img img{
  width: 100%;
  height: 100%;
}
.photos-grid{
  display: grid;
  grid-template-columns: repeat(4,1fr);
  grid-gap: 1.5rem;
}
.photo-item-content button {
  border-radius: 7px;
  border: 1px solid var(--color-theme);
  color: var(--color-theme);
  background-color: white;
}
.photo-item-content button:hover {
  background-color: var(--color-theme);
  color: white;
}
.logo-header-resp>div{
  width: 150px;
}
.logo-header-resp>div img{
  width: 100%;
}
.photo-item-img button{
  width: 30%;
  height: 30%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50% , -50%);
}

@media screen and (max-width: 991px){
  .photos-grid{
    grid-template-columns: repeat(3,1fr);
  }
}
@media screen and (max-width: 767px){
  .photos-grid{
    grid-template-columns: repeat(2,1fr);
  }
}
@media screen and (max-width: 400px){
  .photos-grid{
    grid-template-columns: repeat(1,1fr);
  }
}

#showVideoBox{
  position: fixed;
  left:0;
  top:0;
  width:100%;
  height:100%;
      display: flex;
    justify-content: center;
    align-items: center;
    z-index:100000000;
    background-color:#000000b3;
    z-index: 170;
}
button#closeModal {
    position: fixed;
    right: 1%;
    top: 1%;
    border-radius: 10px;
    padding: 10px;
    background: silver;
    z-index: 100000;
}
</style>